import React from 'react';
import ErrorMessage from 'components/ErrorMessage';
import intl from 'react-intl-universal';
import { Box, makeStyles } from '@material-ui/core';

const AccountExpired = () => {
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <ErrorMessage
        top={intl.get('cantConnectToAccount')}
        middle={intl.get('subscriptionExpired')}
        bottom={intl.get('contactAdmin')}
      />
    </Box>
  );
};

export default AccountExpired;

const useStyles = makeStyles(() => ({
  container: {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'center'
  }
}));
